<template>
  <layout-register :step="step" :title-step="titlePage" class="step-8">
    <div class="container-fluid p0">
      <div class="row">
        <div
          class="col-md-6 col-xs-12 col-sm-12 col-12 membership-selector-container"
          v-for="(membership, index) of memberships"
          :key="index"
        >
          <label>
            <input
              v-model="membershipId"
              class="radio-img"
              type="radio"
              name="test"
              :value="membership.id"
              checked
            />
            <div
              :class="[
                membership.name === 'Frecuente'
                  ? 'bg-card-frecuente-promocion'
                  : 'bg-card-cero',
              ]"
            >
              <div class="radio-card-container">
                <h1 class="radio-card-title">{{ membership.name }}</h1>
                <h1 class="radio-card-price">
                  $ {{ membership.price | formatMoney }}
                  <span class="monthly-text"> /mensual*</span>
                </h1>
                <hr />
                <div class="radio-card-content">
                  <span>
                    {{
                      $t('m122', {
                        min: formatMoney(membership.usagePricePerMin),
                      })
                    }}
                  </span>
                  <br /><br />
                  <span>
                    {{
                      $t('m122', {
                        min: formatMoney(membership.standByPricePerMin),
                      })
                    }}
                  </span>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7 col-xs-12 col-sm-12 col-12">
        <a-btn class="next-step-button" primary @click="sendMembership">
          {{ $t('m15') }} 9
        </a-btn>
      </div>
    </div>
  </layout-register>
</template>

<script>
import ABtn from '@/components/ui/ABtn';

export default {
  name: 'Membership',
  components: {
    ABtn,
  },
  data() {
    return {
      step: 8,
      titlePage: this.$t('m173'),
      membershipId: 13,
      showModal: false,
      memberships: [
        {
          id: 13,
          name: 'Frecuente',
          standByPricePerMin: 65,
          usagePricePerMin: 145,
          price: 4990,
        },
        {
          id: 11,
          name: 'Cero',
          standByPricePerMin: 65,
          usagePricePerMin: 190,
          price: 0,
        },
      ],
    };
  },
  filters: {
    formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2);
    },
  },
  created() {
    this.$store.dispatch('register/getMembership').then(resp => {
      this.memberships = resp;
    });
  },
  methods: {
    sendMembership() {
      this.$store
        .dispatch('register/membership', { membershipId: this.membershipId })
        .then(resp => {
          if (resp.registrationStep) {
            this.$router.push({ name: resp.registrationStep });
          }
        });
    },
    formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2);
    },
  },
};
</script>
